export const CartShippingAddressNavigation = Object.freeze({
    DISPLAY: "DISPLAY",
    EMPTY: "EMPTY",
    LOADING: "LOADING",
});
